import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const ServiceJobTaskTypeUrl = `${Base_Url}/ServiceJobTask`;

export const GetServiceJobTaskList = async (params) => {
  const res = await postApiWithAuthorization(
    `${ServiceJobTaskTypeUrl}/GetServiceJobTaskList?ServiceJobKeyID=${params.serviceJobKeyID}`,
    params
  );
  return res;
};

export const AddUpdateServiceJobTask = async (params) => {
  const res = await postApiWithAuthorization(
    `${ServiceJobTaskTypeUrl}/AddUpdateServiceJobTask?ModuleName=${params.ModuleName}`,
    params
  );
  return res;
};
export const GetServiceJobTaskModel = async (ModuleName, KeyID, AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${ServiceJobTaskTypeUrl}/GetServiceJobTaskModel?ModuleName=${ModuleName}&AdminKeyID=${AdminKeyID}&ServiceJobTaskKeyID=${KeyID}`
  );
  return res;
};

export const ChangeServiceJobTaskStatus = async (
  ModuleName,
  KeyID,
  AdminKeyID
) => {
  const res = await getApiWithAuthorization(
    `${ServiceJobTaskTypeUrl}/ChangeServiceJobTaskStatus?ModuleName=${ModuleName}&AdminKeyID=${AdminKeyID}&ServiceJobTaskKeyID=${KeyID}`
  );
  return res;
};

export const DeleteServiceJobTask = async (ModuleName, KeyID, AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${ServiceJobTaskTypeUrl}/DeleteServiceJobTask?ModuleName=${ModuleName}&AdminKeyID=${AdminKeyID}&ServiceJobTaskKeyID=${KeyID}`
  );
  return res;
};
